module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"Ydral","payTtl":"Diseño y la creación de tiendas online con tecnología de software libre.","payText":" ","payBtn":"MÁS INFORMACIÓN"},"es":{"payTitulo":"Ydral","payTtl":"Diseño y la creación de tiendas online con tecnología de software libre.","payText":" ","payBtn":"MÁS INFORMACIÓN"}}')
  delete Component.options._Ctor
}
